import { useEffect } from 'react'
import { usePromise } from 'shared/hooks/usePromise'
import { useDebounce } from 'shared/hooks/useDebounce.ts'
import { DEBOUNCE_INPUT_TIMEOUT } from 'shared/constants'
import { getCryptoAmount } from './utils'
import { useStreamerConfigContext } from '@/contexts/StreamerConfigContext/StreamerConfigContext'
import { PaymentType } from '@/pages/Donation/api/streamer/types'

type Props = {
  cryptoAssetCode?: string
  baseCurrencyCode?: string
  networkCode?: string
  fiatAmount: string | null
  isIncludeFee: boolean
  paymentType: PaymentType
  minAmountInBaseCurrency: number
}

export const useFinalCryptoAmount = ({
  cryptoAssetCode,
  baseCurrencyCode,
  networkCode,
  fiatAmount,
  isIncludeFee,
  paymentType,
  minAmountInBaseCurrency,
}: Props) => {
  const { username } = useStreamerConfigContext()
  const { data, send, reset, isLoading, error } = usePromise(getCryptoAmount)

  const [debouncedSend] = useDebounce(send, DEBOUNCE_INPUT_TIMEOUT)

  useEffect(() => {
    const isMinAmountError = minAmountInBaseCurrency && (Number(fiatAmount) ?? 0) < minAmountInBaseCurrency
    if (paymentType === PaymentType.Fiat || fiatAmount == null || isMinAmountError) {
      reset()
    } else {
      debouncedSend({
        cryptoAssetCode,
        baseCurrencyCode,
        networkCode,
        fiatAmount,
        isIncludeFee,
        username,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cryptoAssetCode, baseCurrencyCode, networkCode, isIncludeFee, username, paymentType, fiatAmount])

  return {
    data,
    error,
    isLoading,
  }
}
